import Marquee from "react-fast-marquee";
import { CheckCircle2 } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { CtaBanner } from "./Home";
import { IMG, BRAND_LOGOS, BRAND_DETAILS } from "../data/site";

const Brands = () => (
  <div data-testid="brands-page">
    <PageHero eyebrow="PREMIUM BRANDS" title="Authorised installers of the world's best" subtitle="We partner with the most trusted names in heating and cooling — so you get quality that lasts." image={IMG.split} crumbs={[{ label: "Brands" }]} />

    <section className="py-14 bg-js-grey border-b border-black/5">
      <div className="marquee-fade">
        <Marquee speed={40} gradient={false} pauseOnHover>
          {[...BRAND_LOGOS, ...BRAND_LOGOS, ...BRAND_LOGOS, ...BRAND_LOGOS].map((b, i) => (
            <span key={i} className="mx-10 inline-flex items-center h-14 align-middle">
              <img src={b.logo} alt={b.name} className="h-8 md:h-9 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity duration-300" />
            </span>
          ))}
        </Marquee>
      </div>
    </section>

    <section className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid md:grid-cols-2 gap-6">
        {BRAND_DETAILS.map((b, i) => (
          <Reveal key={b.name} delay={i * 0.05}>
            <div className="bg-js-grey rounded-3xl p-8 border border-black/5 h-full hover:-translate-y-1 transition-transform duration-300">
              <span className="font-display font-extrabold text-2xl text-js-blue">{b.name}</span>
              <p className="text-js-charcoal/60 mt-3 leading-relaxed">{b.overview}</p>
              <ul className="mt-5 space-y-2">
                {b.advantages.map((a) => (
                  <li key={a} className="flex items-center gap-2.5 text-sm text-js-charcoal/70"><CheckCircle2 size={17} className="text-js-blue shrink-0" /> {a}</li>
                ))}
              </ul>
              <div className="mt-6 pt-5 border-t border-black/10">
                <p className="text-sm"><span className="font-semibold text-js-charcoal">Why J&amp;S recommends them: </span><span className="text-js-charcoal/60">{b.why}</span></p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
    <CtaBanner />
  </div>
);

export default Brands;
